import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityAttendanceDataSourceReadAction from './legalEntityAttendanceDataSourceRead.action.json' with { type: 'json' }

const legalEntityAttendanceDataSourceReadDefinition = defineReadAutoAction(
  legalEntityAttendanceDataSourceReadAction,
  'legalEntityAttendanceDataSource',
)

export default legalEntityAttendanceDataSourceReadDefinition
